import React, { useState, useEffect, useRef } from "react";
import api from "../../services/api";
import BreadCrumbDiv from "../../components/common/BreadCrumbDiv";
import SearchWrapDiv from "../../components/common/SearchWrapDiv";
import SearchButton from "../../components/common/SearchButton";
import ButtonWrapDiv from "../../components/common/ButtonWrapDiv";
import ListWrapDiv from "../../components/common/ListWrapDiv";
import CodeSelectBox from "../../components/common/CodeSelectBox";
import ActiveButton from "../../components/common/ActiveButton";
import { useMenuAuthInfo, useMultiLang } from "../../services/GlobalUtil";
import { useTranslation } from "react-i18next";
import LoadingBoxDiv from "../../components/common/LoadingBoxDiv";

const AuthorityManagementPage = () => {
  const menuAuthInfo = useMenuAuthInfo();

  const { t } = useTranslation();

  const [authLevel, setAuthLevel] = useState("");
  const searchAuthLevel = useRef("");
  const sbAuthLevel = [
    { code: "", codeDesc: t("L0107") },
    ...useMultiLang("MENU_AUTH"),
  ];

  const [datas, setDatas] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (menuAuthInfo.view) {
      loadContentData();
    }
  }, []);

  const loadContentData = () => {
    setIsLoading(true);

    api
      .post("/manage/authority/view", {
        auth: searchAuthLevel.current,
      })
      .then((response) => {
        setDatas(response.data);
        setIsLoading(false);
      })
      .catch(() => {});
  };

  const handleSearch = () => {
    searchAuthLevel.current = authLevel;

    loadContentData();
  };

  const handleAuthLevelChange = (e) => {
    setAuthLevel(e.target.value);
  };

  const handleMenuAuthChange = (columnName, auth, menuId) => {
    api
      .post("/manage/authority/update", {
        menuId: menuId,
        auth: auth,
        columnNames: [columnName],
      })
      .then(() => {
        loadContentData();
      })
      .catch(() => {});
  };

  return (
    <div>
      <BreadCrumbDiv items={[t("MENU:L0056"), t("MENU:L0087")]}></BreadCrumbDiv>

      <SearchWrapDiv>
        <ButtonWrapDiv>
          <CodeSelectBox
            value={authLevel}
            codes={sbAuthLevel}
            onChange={handleAuthLevelChange}
            isCodeVisible={false}
            multiple={false}
          ></CodeSelectBox>
          <SearchButton onClick={handleSearch}></SearchButton>
        </ButtonWrapDiv>
      </SearchWrapDiv>

      <LoadingBoxDiv loading={isLoading}>
        <ListWrapDiv>
          <table>
            <thead>
              <tr>
                <th style={{ width: "auto" }}>Menu Name</th>
                <th style={{ width: "7%" }}>UseYN</th>
                <th style={{ width: "5%" }}>ALL</th>
                <th style={{ width: "5%" }}>View</th>
                <th style={{ width: "5%" }}>Reg</th>
                <th style={{ width: "5%" }}>Edit</th>
                <th style={{ width: "5%" }}>Del</th>
              </tr>
            </thead>
            <tbody>
              {datas.map((data, rowIndex) => (
                <tr key={rowIndex}>
                  <td
                    style={{
                      textAlign: "left",
                      fontWeight:
                        data.menuLevel === 0 || data.menuLevel === 1
                          ? "bold"
                          : "normal",
                      fontSize: data.menuLevel === 0 ? "10pt" : "inherit",
                    }}
                  >
                    {"\u00A0".repeat(data.menuLevel * 3)}
                    {data.menuLevel !== 0 && "└\u00A0\u00A0"}
                    {data.menuDesc}
                  </td>
                  <td>{data.useYn ? "Y" : "N"}</td>
                  <td>
                    <button
                      style={{
                        background: "none",
                        border: "none",
                        color: "#002c5f",
                        textDecoration: menuAuthInfo.edit
                          ? "underline"
                          : "none",
                        cursor: menuAuthInfo.edit ? "pointer" : "default",
                      }}
                      onClick={
                        menuAuthInfo.edit
                          ? () =>
                              handleMenuAuthChange(
                                "ALL",
                                data.auth,
                                data.menuId
                              )
                          : undefined
                      }
                    >
                      All
                    </button>
                  </td>
                  <td>
                    <ActiveButton
                      onClick={
                        menuAuthInfo.edit
                          ? () =>
                              handleMenuAuthChange(
                                "View",
                                data.auth,
                                data.menuId
                              )
                          : undefined
                      }
                      isActive={data.view}
                      style={{
                        cursor: menuAuthInfo.edit ? "pointer" : "default",
                      }}
                    ></ActiveButton>
                  </td>
                  <td>
                    <ActiveButton
                      onClick={
                        menuAuthInfo.edit
                          ? () =>
                              handleMenuAuthChange(
                                "Reg",
                                data.auth,
                                data.menuId
                              )
                          : undefined
                      }
                      isActive={data.reg}
                      style={{
                        cursor: menuAuthInfo.edit ? "pointer" : "default",
                      }}
                    ></ActiveButton>
                  </td>
                  <td>
                    <ActiveButton
                      onClick={
                        menuAuthInfo.edit
                          ? () =>
                              handleMenuAuthChange(
                                "Edit",
                                data.auth,
                                data.menuId
                              )
                          : undefined
                      }
                      isActive={data.edit}
                      style={{
                        cursor: menuAuthInfo.edit ? "pointer" : "default",
                      }}
                    ></ActiveButton>
                  </td>
                  <td>
                    <ActiveButton
                      onClick={
                        menuAuthInfo.edit
                          ? () =>
                              handleMenuAuthChange(
                                "Del",
                                data.auth,
                                data.menuId
                              )
                          : undefined
                      }
                      isActive={data.del}
                      style={{
                        cursor: menuAuthInfo.edit ? "pointer" : "default",
                      }}
                    ></ActiveButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </ListWrapDiv>
      </LoadingBoxDiv>
    </div>
  );
};

export default AuthorityManagementPage;
